import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import { GetEventInput } from '../../apiTypes';
import { typeEvents } from './types';

const getEventQuery = (variables: GetEventInput): QueryInfos => {
    const { event } = variables;
    return {
        name: `event-${event}`,
        path: `/events/${event}/access`,
        type: typeEvents.GET_EVENT,
        params: {},
    };
};

export function useGetEvent<T>(options: Options<GetEventInput>): UseQueryResult<T, Error> {
    return useMyQuery<T, GetEventInput>(getEventQuery, options);
}
